function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DEFAULT_TPL_FIELDS, ACCESS_TYPE_FLOW, TYPE_CHANGE_METADA, GA_EVENTS } from '@/js/constants';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import { mapState } from 'vuex';
import MyPendingsService from '@/apps/data-platform/services/tables_views/my_pendings_service';
import ListTableMetadataColsComponent from '@/apps/data-platform/components/ListTableMetadataColsComponent.vue';
import FormTemporalAssignment from '@/components/tableau/FormTemporalAssignment';
export default {
  name: 'FormAccessResponse',
  components: {
    ListTableMetadataColsComponent: ListTableMetadataColsComponent
  },
  props: {
    tplToWork: {
      type: Object,
      required: true
    },
    isOnlyView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      defaultFields: null,
      columnFields: [],
      // response from Api
      columnFieldsLabels: [{
        key: 'column',
        sortable: true,
        stickyColumn: true,
        isRowHeader: true
      }, {
        label: 'Description',
        key: 'templateDisplayName',
        stickyColumn: true,
        isRowHeader: true
      }, {
        label: 'Required',
        key: 'include_in_flow'
      }],
      submitButton: null,
      filter: null,
      filterOn: [],
      toCreateView: {},
      invalidDate: false,
      valid: true,
      menu_calendar: null
    };
  },
  created: function created() {
    console.log("onlyviewform", this.isOnlyView);
    // Separe defaultTemplate and Columnfields
    var separeValues = tasks.filterDefaultTableTagsAndColumnFields(this.tplToWork.fields);
    this.defaultFields = separeValues.defaultFields;
    this.columnFields = separeValues.columnFields;

    // set save to send object
    this.toCreateView.projectId = this.tplToWork.tableReference.projectId;
    this.toCreateView.datasetId = this.tplToWork.tableReference.datasetId;
    this.toCreateView.tableId = this.tplToWork.tableReference.tableId;
    this.toCreateView.fields = this.tplToWork.fields; // are tags
    this.toCreateView.endDate = this.tplToWork.endDate;
    this.toCreateView.created = this.tplToWork.created;
    this.toCreateView.tableReference = this.tplToWork.tableReference;
    this.toCreateView.id_firestore = this.tplToWork.id_firestore;
    this.toCreateView.response = this.tplToWork.response;
    this.toCreateView.email = this.tplToWork.applicant;
    this.toCreateView.relativeResourceName = this.tplToWork.relativeResourceName;
    this.toCreateView.index_node = this.tplToWork.index_node != null && this.tplToWork.index_node >= 0 ? this.tplToWork.index_node : -1;
    this.toCreateView.domain_table = this.tplToWork.domain_table;
    // access response
    this.toCreateView.applicant = this.tplToWork.applicant;
    this.toCreateView.benefited = this.tplToWork.benefited;
    this.toCreateView.business_case = this.tplToWork.business_case;
    this.toCreateView.isServiceAccount = this.tplToWork.isServiceAccount;
    this.toCreateView.isExternalUser = this.tplToWork.isExternalUser || false;
    this.toCreateView.source = this.tplToWork.source;
    this.toCreateView.sandbox = this.tplToWork.sandbox;
    this.toCreateView.service_account_type = this.tplToWork.service_account_type;
  },
  methods: {
    fechas: function fechas() {
      if (this.toCreateView.endDate) {
        var inicio = new Date(this.tplToWork.created);
        var final = new Date(this.toCreateView.endDate);
        var resultado = final - inicio;
        if (resultado >= 0) {
          this.invalidDate = false;
        } else {
          this.invalidDate = true;
        }
      }
    },
    focusRequiredComponent: function focusRequiredComponent() {
      var _iterator = _createForOfIteratorHelper(this.$refs.form.$children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;
          if (el.valid === false) {
            el.focus();
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.focusRequiredComponent();
        return;
      }
      if (this.submitButton === 'ok') {
        this.approve();
      } else {
        this.onRefuse();
      }
    },
    onAccept: function onAccept() {
      if (!this.$refs.form.validate()) {
        this.focusRequiredComponent();
        return;
      }
      var responseToSend = utils.cloneJSON(this.toCreateView);
      responseToSend.endDate = utils.dateBrowserToService(responseToSend.endDate);
      responseToSend.fieldsToDriverConnection = utils.driverConnectionFormat(responseToSend.fields);
      responseToSend.fields = utils.extractCellNameForView(responseToSend.fields); // tags_name
      // send to create view
      if (responseToSend.fields.length > 0) {
        this.$emit('onAccept', responseToSend);
      } else {
        tasks.toast.error('You must choose at least one row from the required column.');
      }
    },
    approveAutomatic: function approveAutomatic() {
      var _this = this;
      // Marca la tabla como aprobación automática y aprueba TODAS las solicitudes pendientes de esa tabla.
      // Envía los mismos campos que approve() para la solicitud actual (endDate, fields, area, etc.).
      if (!this.toCreateView.response) {
        this.toCreateView.response = "Aprobación automática.";
      }
      if (!this.$refs.form.validate()) {
        this.focusRequiredComponent();
        return;
      }
      var responseToSend = utils.cloneJSON(this.toCreateView);
      var area = this.defaultFields.area.stringValue;
      responseToSend.endDate = utils.dateBrowserToService(responseToSend.endDate);
      responseToSend.fieldsToDriverConnection = utils.driverConnectionFormat(responseToSend.fields);
      responseToSend.fields = utils.extractCellNameForView(responseToSend.fields); // tags_name
      if (responseToSend.fields.length > 0) {
        var params = {
          user: responseToSend.applicant,
          projectId: responseToSend.projectId,
          datasetId: responseToSend.datasetId,
          tableId: responseToSend.tableId,
          fields: responseToSend.fields,
          endDate: responseToSend.endDate,
          id_firestore: responseToSend.id_firestore,
          relativeResourceName: responseToSend.relativeResourceName,
          ownerResponse: responseToSend.response,
          area: area,
          index_node: responseToSend.index_node,
          domain_table: responseToSend.domain_table,
          fieldsToDriverConnection: responseToSend.fieldsToDriverConnection,
          benefited: responseToSend.benefited,
          business_case: responseToSend.business_case,
          isServiceAccount: responseToSend.isServiceAccount,
          isExternalUser: responseToSend.isExternalUser,
          response: responseToSend.response,
          source: responseToSend.source,
          sandbox: responseToSend.sandbox,
          service_account_type: responseToSend.service_account_type,
          authorization_type: 'automatic'
        };
        MyPendingsService.setAutomaticApproval(params).then(function (response) {
          if (response.success) {
            if (_this.$gtm.enabled() && window.dataLayer) {
              window.dataLayer.push({
                event: GA_EVENTS.ACCESS_REQUEST_MANAGEMENT,
                object: 'table',
                domain_object: responseToSend.domain_table,
                company_code: _this.companyCode,
                id_object: responseToSend.projectId + '.' + responseToSend.datasetId + '.' + responseToSend.tableId,
                status: 'auto_approved',
                hash_email: _this.stringToHash(userInfo.email),
                module: 'data_platform'
              });
            }
            _this.$emit('submit', responseToSend);
            tasks.toast.success(response.message);
          } else {
            tasks.toast.error(response.message);
          }
        }).catch(function (e) {
          utils.printError(e);
        });
      } else {
        tasks.toast.error('You must choose at least one row from the required column.');
      }
    },
    approve: function approve() {
      var _this2 = this;
      if (!this.toCreateView.response) {
        this.toCreateView.response = "Aprobación masiva.";
      }
      if (!this.$refs.form.validate()) {
        this.focusRequiredComponent();
        return;
      }
      // prepare to send
      var responseToSend = utils.cloneJSON(this.toCreateView);
      console.log("to_send", responseToSend);
      var area = this.defaultFields.area.stringValue;
      responseToSend.endDate = utils.dateBrowserToService(responseToSend.endDate);
      responseToSend.fieldsToDriverConnection = utils.driverConnectionFormat(responseToSend.fields);
      responseToSend.fields = utils.extractCellNameForView(responseToSend.fields); // tags_name
      // send to create view
      if (responseToSend.fields.length > 0) {
        var params = {
          user: responseToSend.applicant,
          projectId: responseToSend.projectId,
          datasetId: responseToSend.datasetId,
          tableId: responseToSend.tableId,
          fields: responseToSend.fields,
          endDate: responseToSend.endDate,
          id_firestore: responseToSend.id_firestore,
          relativeResourceName: responseToSend.relativeResourceName,
          ownerResponse: responseToSend.response,
          area: area,
          index_node: responseToSend.index_node,
          domain_table: responseToSend.domain_table,
          fieldsToDriverConnection: responseToSend.fieldsToDriverConnection,
          benefited: responseToSend.benefited,
          business_case: responseToSend.business_case,
          isServiceAccount: responseToSend.isServiceAccount,
          isExternalUser: responseToSend.isExternalUser,
          response: responseToSend.response,
          source: responseToSend.source,
          sandbox: responseToSend.sandbox,
          service_account_type: responseToSend.service_account_type
        };
        MyPendingsService.approve(params).then(function (response) {
          if (response.success) {
            if (_this2.$gtm.enabled() && window.dataLayer) {
              window.dataLayer.push({
                event: GA_EVENTS.ACCESS_REQUEST_MANAGEMENT,
                object: 'table',
                domain_object: responseToSend.domain_table,
                benefited: _this2.stringToHash(responseToSend.applicant),
                company_code: _this2.companyCode,
                id_object: responseToSend.projectId + '.' + responseToSend.datasetId + '.' + responseToSend.tableId,
                status: "approved",
                hash_email: _this2.stringToHash(userInfo.email),
                module: 'data_platform'
              });
            }
            _this2.$emit('submit', responseToSend);
            tasks.toast.success(response.message);
          } else {
            tasks.toast.error(response.message);
          }
          //tag
          /*if (response.code !== 500) {
            this.$bvModal.hide(this.MODAL_NAME_ACCESS)
            tasks.toast.success(response.message)
          }*/
        }).catch(function (e) {
          utils.printError(e);
          // this.approve()
        });
      } else {
        tasks.toast.error('You must choose at least one row from the required column.');
        // alert('You must choose at least one row from the required column.')
      }
    },
    onCancel: function onCancel(event) {
      event.preventDefault();
      this.$emit('cancel', null);
    },
    onRefuse: function onRefuse() {
      if (!this.$refs.form.validate()) {
        this.focusRequiredComponent();
        return;
      }
      var responseToSend = utils.cloneJSON(this.toCreateView);
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.ACCESS_REQUEST_MANAGEMENT,
          object: 'table',
          domain_object: responseToSend.domain_table,
          benefited: this.stringToHash(responseToSend.applicant),
          company_code: this.companyCode,
          id_object: responseToSend.projectId + '.' + responseToSend.datasetId + '.' + responseToSend.tableId,
          status: "rejected",
          hash_email: this.stringToHash(userInfo.email),
          module: 'data_platform'
        });
      }
      this.$emit('refuse', this.toCreateView);
    }
  },
  computed: _objectSpread({}, mapState('data-platform', ['companyCode', 'companyName']))
};